import { render, staticRenderFns } from "./GroupCpc.vue?vue&type=template&id=0a3ac8a6&scoped=true&"
import script from "./GroupCpc.vue?vue&type=script&lang=js&"
export * from "./GroupCpc.vue?vue&type=script&lang=js&"
import style0 from "./GroupCpc.vue?vue&type=style&index=0&id=0a3ac8a6&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0a3ac8a6",
  null
  
)

export default component.exports